import React from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import t from '@jetshop/intl';
import { theme } from '../Theming/Theming';

const MenuWrapper = styled('div')`
  margin: 2rem 0;
  ${theme.below.md} {
    margin: 1rem 0;
  }
  > ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    border-bottom: 1px solid #eee;
    > li {
      display: inline-block;
      padding: 0.5rem;
      margin-right: 1rem;
      position: relative;
      top: 1px;
      > a {
        display: inline-block;
        text-decoration: none;
      }
      &.active {
        border-bottom: 1px solid ${theme.colors.borderDark};
        > a {
        }
      }
      &:last-child {
      }
    }
  }
`;
const MenuItemName = styled('h4')``;

const BlogMenu = ({ categories, mainPath, pathname }) => {
  return (
    <MenuWrapper>
      <ul>
        {categories.map((category) => (
          <li
            key={category.id}
            className={
              category.primaryRoute?.path === pathname ? 'active' : null
            }
          >
            <MenuItemName>
              <CategoryLink category={category}>
                {mainPath === category.primaryRoute?.path
                  ? t('Show all')
                  : category.name}
              </CategoryLink>
            </MenuItemName>
          </li>
        ))}
      </ul>
    </MenuWrapper>
  );
};

export default BlogMenu;
